// Author action types
export const FETCH_AUTHORS_REQUEST = 'FETCH_AUTHORS_REQUEST';
export const FETCH_AUTHORS_SUCCESS = 'FETCH_AUTHORS_SUCCESS';
export const FETCH_AUTHORS_FAILURE = 'FETCH_AUTHORS_FAILURE';

export const FETCH_AUTHOR_BY_SLUG_REQUEST = 'FETCH_AUTHOR_BY_SLUG_REQUEST';
export const FETCH_AUTHOR_BY_SLUG_SUCCESS = 'FETCH_AUTHOR_BY_SLUG_SUCCESS';
export const FETCH_AUTHOR_BY_SLUG_FAILURE = 'FETCH_AUTHOR_BY_SLUG_FAILURE';

export const FETCH_AUTHOR_ARTICLES_REQUEST = 'FETCH_AUTHOR_ARTICLES_REQUEST';
export const FETCH_AUTHOR_ARTICLES_SUCCESS = 'FETCH_AUTHOR_ARTICLES_SUCCESS';
export const FETCH_AUTHOR_ARTICLES_FAILURE = 'FETCH_AUTHOR_ARTICLES_FAILURE';

export const CREATE_AUTHOR_REQUEST = 'CREATE_AUTHOR_REQUEST';
export const CREATE_AUTHOR_SUCCESS = 'CREATE_AUTHOR_SUCCESS';
export const CREATE_AUTHOR_FAILURE = 'CREATE_AUTHOR_FAILURE';

export const UPDATE_AUTHOR_REQUEST = 'UPDATE_AUTHOR_REQUEST';
export const UPDATE_AUTHOR_SUCCESS = 'UPDATE_AUTHOR_SUCCESS';
export const UPDATE_AUTHOR_FAILURE = 'UPDATE_AUTHOR_FAILURE';

export const DELETE_AUTHOR_REQUEST = 'DELETE_AUTHOR_REQUEST';
export const DELETE_AUTHOR_SUCCESS = 'DELETE_AUTHOR_SUCCESS';
export const DELETE_AUTHOR_FAILURE = 'DELETE_AUTHOR_FAILURE';


